<template>
  <section class="home-words">
    <div class="words-decor words-decor--left">
      <img v-lazy="require('../../../static/images/home/words-left.jpg')" alt="">
    </div>
    <div class="words-decor words-decor--right">
      <img v-lazy="require('../../../static/images/home/words-right.jpg')" alt="">
    </div>
    <header>
      <h2>{{ $t('home.testimonialsTitle') }}</h2>
    </header>
    <div class="container">
      <div class="testimonials-stagger">
        <div v-for="(item, index) in frontItems" :key="index"
             class="stagger-card"
             :class="'stagger-card--' + (index + 1)">
          <div class="stagger-card__inner">
            <div class="quote-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z"/>
              </svg>
            </div>
            <p class="stagger-card__text">{{ item.contents }}</p>
            <div class="stagger-card__author">
              <span>{{ item.username }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="words-cta">
        <button class="btn-words-cta" @click="$emit('start')">{{ $t('home.wordsCta') }} <span class="cta-arrow"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></span></button>
      </div>
    </div>
  </section>
</template>

<script>
import api from 'src/api/'

export default {
  name: 'HomeWords',
  data () {
    return {
      frontItems: [],
      dataLoaded: false
    }
  },
  created () {
    if (process.browser) {
      this.fetchStatements().then(data => {
        const items = data.splice(-4)
        if (items.length >= 3) {
          const temp = items[0]
          items[0] = items[2]
          items[2] = temp
        }
        this.frontItems = items
      })
    }
  },
  methods: {
    fetchStatements () {
      const language = this.$store.state.language.substr(0, 2)
      return api.fetchTestimonials(this.page, language).then(data => {
        data = data.data
        data.map(item => {
          item.image = `${item.images[0]}!320`
          item.avatar = `${item.avatar}!320`
        })
        return data
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
.home-words {
  background-color: #f8f9fc;
  padding: 5rem 1.5rem;
  position: relative;
  overflow: hidden;

  .words-decor {
    position: absolute;
    width: 300px;
    pointer-events: none;
    z-index: 0;

    img {
      width: 100%;
      height: auto;
      display: block;
      opacity: 0.35;
      border-radius: 8px;
    }

    &--left {
      left: -30px;
      top: 50%;
      transform: rotate(8deg) translateY(-50%);

      &::after {
        content: '';
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background: radial-gradient(ellipse at center, transparent 0%, transparent 20%, rgba(248, 249, 252, 0.7) 55%, rgba(248, 249, 252, 0.95) 80%);
        border-radius: 8px;
        z-index: 1;
      }

      &::before {
        content: '';
        position: absolute;
        top: -60%; left: -50%; right: -50%; bottom: -60%;
        background: radial-gradient(ellipse at center, rgba(200, 180, 240, 0.7) 0%, rgba(180, 210, 255, 0.4) 35%, transparent 65%);
        filter: blur(40px);
        z-index: -1;
      }
    }

    &--right {
      right: -30px;
      top: 50%;
      transform: rotate(-10deg) translateY(-50%);

      &::after {
        content: '';
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background: radial-gradient(ellipse at center, transparent 0%, transparent 20%, rgba(248, 249, 252, 0.7) 55%, rgba(248, 249, 252, 0.95) 80%);
        border-radius: 8px;
        z-index: 1;
      }

      &::before {
        content: '';
        position: absolute;
        top: -60%; left: -50%; right: -50%; bottom: -60%;
        background: radial-gradient(ellipse at center, rgba(170, 230, 220, 0.65) 0%, rgba(180, 240, 210, 0.35) 35%, transparent 65%);
        filter: blur(40px);
        z-index: -1;
      }
    }
  }

  header, .container {
    position: relative;
    z-index: 1;
  }

  header {
    text-align: center;
    margin-bottom: 3rem;
  }

  .testimonials-stagger {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: 1.5rem;
    max-width: 1400px;
    margin: 0 auto;
    min-height: 420px;
    padding-bottom: 2rem;
  }

  .stagger-card {
    flex: 1;
    max-width: 320px;
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-8px);
    }

    // Staggered heights
    &--1 { align-self: flex-end; margin-bottom: 0; }
    &--2 { align-self: flex-start; margin-top: 3rem; }
    &--3 { align-self: flex-end; margin-bottom: 1.5rem; }
    &--4 { align-self: flex-start; margin-top: 4.5rem; }

    &__inner {
      background: #fff;
      border-radius: 16px;
      padding: 1.75rem;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
      border: 1px solid #f0f0f5;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: linear-gradient(to right, $el-color-primary, lighten($el-color-primary, 20%));
        border-radius: 16px 16px 0 0;
      }
    }

    &__text {
      font-size: 0.9375rem;
      color: #374151;
      line-height: 1.7;
      margin-bottom: 1.25rem;
      display: block;
    }

    &__author {
      border-top: 1px solid #f3f4f6;
      padding-top: 0.75rem;

      span {
        font-size: 0.875rem;
        font-weight: 700;
        color: #1a1a2e;

        &::before {
          content: "\2014 ";
          color: $el-color-primary;
          margin-right: 4px;
        }
      }
    }
  }

  .quote-icon {
    color: $el-color-primary;
    opacity: 0.25;
    margin-bottom: 0.5rem;

    svg {
      width: 22px;
      height: 22px;
    }
  }

  .words-cta {
    text-align: center;
    margin-top: 2.5rem;
  }

  .btn-words-cta {
    display: inline-flex;
    align-items: center;
    padding: 0.875rem 3rem;
    background-color: $el-color-primary;
    color: #fff;
    font-size: 1.0625rem;
    font-weight: 600;
    border-radius: 100px;
    border: none;
    cursor: pointer;
    transition: all 0.25s;

    &:hover {
      background: linear-gradient(to right, #F56368, #ff878b);
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(124, 58, 237, 0.4);
    }
  }
}

@media (max-width: 1024px) {
  .home-words .testimonials-stagger {
    flex-wrap: wrap;
    align-items: stretch;

    .stagger-card {
      flex: 0 0 calc(50% - 0.75rem);
      max-width: none;
      margin: 0 !important;
      align-self: auto !important;
    }
  }
}

@media (max-width: 768px) {
  .home-words {
    padding: 3.5rem 1rem;

    .words-decor {
      display: none;
    }

    .testimonials-stagger {
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      min-height: auto;
      padding-bottom: 0;

      .stagger-card {
        flex: none;
        width: 100%;
        max-width: 100%;
        margin: 0 !important;
      }
    }

    .stagger-card__inner {
      padding: 1.5rem;
    }
  }
}
</style>
